import { render, staticRenderFns } from "./MyLitters.vue?vue&type=template&id=284f8d18"
import script from "./MyLitters.vue?vue&type=script&lang=ts"
export * from "./MyLitters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports